import ApiService from '@/services/ApiService';
import ApiEndpoints from '@/config/ApiEndpoints';

export default class CreateSubscription {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService

    /**
     * CreateSubscription constructor.
     *
     * @returns {void}
     */
    constructor(apiService = null) {
        this.apiService = apiService || new ApiService(process.env.VUE_APP_API_URL);

        this.apiService.enableAuth();
    }

    /**
     * Handle creating a new subscription for the customer.
     *
     * @param {*} payload
     *
     * @return {Promise}
     */
    handle(payload) {
        let apiUrl = ApiEndpoints['subscriptions.store'];
        let parameters = {
            first_name: payload.firstName,
            last_name: payload.lastName,
            house: payload.houseNumber,
            address1: payload.address1,
            address2: payload.address2 || null,
            city: payload.city,
            country: payload.country,
            postcode: payload.postcode,
            delivery_comment: payload.deliveryComment,
            property_type: payload.propertyType,
        };

        return this.apiService.post(apiUrl, parameters);
    }
}
